<!--
 * @Description: 确认核对表
 * @Author: ll
 * @Date: 2021-9-7 10:35:30
 * @LastEditTime: 
 * @LastEditors: ll
-->
<template>
  <div class="bq-checklist">
    <a-modal :visible="checkVisible" @cancel="cancel" width="700px">
      <div slot="title" class="cr-flex cr-ai-center">
        <span class="cr-text-black-2">确认核对表</span>
        <span class="cr-in-block cr-ml-1 cr-fs-md cr-text-grey-2">案件编号：{{ caseNo }}</span>
      </div>
      <div slot="footer" class="cr-flex cr-jc-between">
        <div><a-button @click="downFile" class="cr-text-primary cr-border-primary"> 下载文件 </a-button></div>
        <div>
          <a-button class="cr-text-red cr-border-red" @click="handleCancel"> 表格有误 </a-button>
          <a-button type="primary" @click="handleOk"> 确认无误 </a-button>
        </div>
      </div>
      <div class="bq-checkCont">
        <div class="bq-according cr-mb-2">
          <img :src="CheckForm[checkIndex]" @click="openImg(CheckForm[checkIndex])" />
        </div>
        <div class="bq-switch cr-flex">
          <span :class="{ active: index == checkIndex }" v-for="(Check, index) in CheckForm" :key="index" @click="checkSwitch(index)">{{ index + 1 }}</span>
        </div>
      </div>
    </a-modal>
    <a-modal :visible="isVisible" width="440px" @cancel="isVisible = false">
      <p class="cr-pt-5">确认表格有误成功， <br />请检查您的案件信息并再次提交？</p>
      <template slot="footer">
        <a-button @click="modified"> 稍后提交 </a-button>
        <a-button type="primary" @click="jumpDetail"> 去修改确认 </a-button>
      </template>
    </a-modal>
    <div v-show="imgurl" class="showimg">
      <div class="zhezhao" />
      <img :src="imgurl" class="pic" />
      <div class="close" @click="closeimg">X</div>
    </div>
  </div>
</template>

<script>
import { confirmMistake, confirmNoMistake } from '@/api/caseManage.js'
import { showCheckForm } from '@/api/caseManage'
export default {
  props: {
    checkVisible: {
      type: Boolean,
      default: false
    },
    caseNo: String
  },
  data() {
    return {
      isVisible: false,
      checkIndex: 0,
      CheckForm: [],
      zipUrl: '',
      imgurl: ''
    }
  },
  created() {
    this.getCheckList()
  },
  methods: {
    // 确认核对表
    async getCheckList() {
      let data = {
        caseNo: this.caseNo
      }
      const res = await showCheckForm(data)
      if (res.data) {
        this.CheckForm = res.data.imgUrlList || []
        this.zipUrl = res.data.zipUrl
      }
    },
    checkSwitch(index) {
      this.checkIndex = index
    },
    closeimg() {
      this.imgurl = undefined
    },
    openImg(url) {
      this.imgurl = url
    },
    async handleOk() {
      let data = {
        caseNo: this.caseNo
      }
      const res = await confirmNoMistake(data)
      if (res.code === 0) {
        this.$emit('update:checkVisible', false)
        this.$emit('refresh')
      }
    },
    cancel() {
      this.$emit('update:checkVisible', false)
    },
    async handleCancel() {
      let data = {
        caseNo: this.caseNo
      }
      const res = await confirmMistake(data)
      if (res.code == 0) {
        this.$emit('update:checkVisible', false)
        this.isVisible = true
      }
    },
    downFile() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.zipUrl
      link.setAttribute('download', '核对表')
      document.body.appendChild(link)
      link.click()
    },
    // 去确认修改
    jumpDetail() {
      this.$router.push({
        path: '/businessCenter/caseDetail',
        query: {
          caseNo: this.caseNo
        }
      })
    },
    // 稍后修改
    modified() {
      this.isVisible = false
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-modal-content {
  font-size: 14px;
  color: #333;
  .ant-modal-header {
    border: 0;
  }
  .ant-modal-body {
    padding: 0 24px;
    .bq-checkCont {
      overflow: auto;
      .bq-according {
        width: 652px;
        height: 427px;
        border-radius: 3px;
        border: 1px solid #d9d9d9;
        img {
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
      }
      .bq-switch {
        span {
          display: inline-block;
          border-radius: 50%;
          line-height: 24px;
          width: 24px;
          height: 24px;
          background: #f0f0f0;
          margin-right: 12px;
          color: #999;
          text-align: center;
          cursor: pointer;
        }
        .active {
          background: rgba(71, 186, 151, 0.1);
          color: #47ba97;
        }
      }
    }
  }
  .ant-modal-footer {
    border: 0;
    padding: 24px 16px;
  }
}
.showimg {
  .zhezhao {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.7;
    z-index: 1001;
  }
  .pic {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
    max-width: 1000px;
  }
  .close {
    position: fixed;
    top: 80px;
    right: 80px;
    width: 60px;
    height: 60px;
    background-color: #eee;
    border-radius: 50%;
    color: #666;
    font-size: 40px;
    text-align: center;
    line-height: 60px;
    z-index: 1001;
    cursor: pointer;
    opacity: 0.7;
  }
}
</style>
